export enum ContentTypes {
    DigitalSignagePage = "Digital Signage Page",
    PrintableNewsletter = "Printable Newsletter"
}